import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import Header from './components/Header/Header';
import Dashboard from './components/Dashboard/Dashboard';
import MessageTemplates from './components/MessageTemplates/MessageTemplates';
import Automations from './components/Automations/Basic';
import 'bootstrap/dist/css/bootstrap.min.css';
import MessageTemplateForm from './components/MessageTemplates/MessageTemplateForm';
import ContactTable from './components/Contacts/Contacts';
import AddContact from './components/Contacts/AddContactForm';
import ImportExportContacts from './components/Contacts/ImportExportContacts';
import ContactListsAndTags from './components/Contacts/ContactListsAndTags';
import NotificationTable from './components/Notifications/Notifications';
import AddNotification from './components/Notifications/AddNotification';
import Messaging from './components/Analytics/Messaging';
import NotificationAnalytics from './components/Analytics/NotificationAnalytics';
import MessageTemplatesAnalytics from './components/Analytics/MessageTemplatesAnalytics';
import Basic from './components/Automations/Basic';
import AutoReplies from './components/Automations/AutoReplies';
import ChatApp from './components/Inbox/Inbox';
import AccountDetails from './components/Profile/AccountDetails';
import Login from './components/Login/Login';
import MessageTempView from './components/MessageTemplates/MessageTempView';
import EmRegistation from './components/Login/EmRegistation';
import AdminApprovalPage from './components/Login/ApproveReject';
import LoginPass from './components/Login/loginPass';
import MessagePanel from './components/Dashboard/MessagePanel';
import SendMessaging from './components/Dashboard/SendMessaging';


const App = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/';
    const isRegistrationPage = location.pathname === '/em-registation';
    const isApprovePage = location.pathname === '/adminapprove';
    const isLoginPass = location.pathname === '/loginpass-login';

    return (
        <div className="d-flex flex-column flex-md-row vh-100">
            {!isLoginPage && !isRegistrationPage && !isApprovePage && !isLoginPass && <Sidebar />}
            <div className="flex-grow-1 d-flex flex-column">
                {!isLoginPage && !isRegistrationPage && !isApprovePage && !isLoginPass && <Header />}
                <div className="p-3 overflow-auto" style={{ backgroundColor: '#f8f9fa' }}>
                    <Routes>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/MessagePanel/Message-Panel" element={<MessagePanel />} />
                        <Route path="/" element={<Login />} />
                        <Route path="/loginpass-login" element={<LoginPass />} />
                        <Route path="/adminapprove" element={<AdminApprovalPage />} />
                        <Route path="/em-registation" element={<EmRegistation />} />
                        <Route path="/send-messaging" element={<SendMessaging />} />
                        <Route path="/message-templates" element={<MessageTemplates />} />
                        <Route path="/message-temp-view" element={<MessageTempView />} />
                        <Route path="/singlecontacts" element={<ContactTable />} />
                        <Route path="/notifications" element={<NotificationTable />} />
                        <Route path="/messaging" element={<Messaging />} />
                        <Route path="/automations" element={<Automations />} />
                        <Route path="/inbox" element={<ChatApp />} />
                        <Route path='/add-templates' element={<MessageTemplateForm />} />
                        <Route path='/add-new' element={<AddContact />} />
                        <Route path='/import-export' element={<ImportExportContacts />} />
                        <Route path='/list-tags' element={<ContactListsAndTags />} />
                        <Route path='/add-notification' element={<AddNotification />} />
                        <Route path='/notificationss' element={<NotificationAnalytics />} />
                        <Route path='/message-templates-analytics' element={<MessageTemplatesAnalytics />} />
                        <Route path='/basic' element={<Basic />} />
                        <Route path='/auto-replies' element={<AutoReplies />} />
                        <Route path='/profile' element={<AccountDetails />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
};

const Root = () => (
    <Router>
        <App />
    </Router>
);

export default Root;
